import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import reservationsService from "../../services/rentals/reservationsService";
import EntityList from "../../components/EntityList";

export default function ReservationsList() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  async function load() {
    try {
      const res = await reservationsService.listReservations();
      setItems(res.items || res || []);
    } catch (e) {
      console.error("failed loading reservations", e);
    }
  }

  useEffect(() => {
    load();
  }, []);

  const columns = [
    {
      key: "bookingCode",
      label: "Booking",
      render: (r) => r.booking_id || r.reservation_id || r._id,
    },
    {
      key: "asset",
      label: "Asset",
      render: (r) => {
        const asset = r.asset || (r.asset_id ? { asset_id: r.asset_id } : null);
        if (!asset) return "-";
        if (asset.make && asset.model) return `${asset.make} ${asset.model}`;
        return asset.asset_id || asset.assetId || asset.name || "-";
      },
    },
    {
      key: "fromDate",
      label: "From",
      render: (r) =>
        r.start_time ? new Date(r.start_time).toLocaleString() : "-",
    },
    {
      key: "toDate",
      label: "To",
      render: (r) => (r.end_time ? new Date(r.end_time).toLocaleString() : "-"),
    },
    {
      key: "price",
      label: "Price",
      render: (r) => {
        if (typeof r.final_price === "number") {
          const cur = r.currency || (r.pricing && r.pricing.currency) || "USD";
          return `${cur} ${r.final_price}`;
        }
        // fallback to pricing.base_price
        if (r.pricing && typeof r.pricing.base_price === "number") {
          const cur = r.currency || "USD";
          return `${cur} ${r.pricing.base_price}`;
        }
        return "-";
      },
    },
    {
      key: "payment",
      label: "Payment",
      render: (r) => {
        if (r.payment)
          return `${r.payment.status || "-"} (${r.payment.method || "-"})`;
        return "-";
      },
    },
    {
      key: "status",
      label: "Status",
      render: (r) => r.state || r.status || "-",
    },
    { key: "actions", label: "Actions", render: () => "⋮" },
  ];

  return (
    <EntityList
      title="Reservations"
      subtitle="Manage reservations"
      items={items}
      columns={columns}
      onNew={() => navigate("/rentals/reservations/new")}
      onRowClick={(r) =>
        navigate(`/rentals/reservations/${r.reservation_id || r._id}`)
      }
    />
  );
}
